<template>
  <div class="code">
    <div class="code-container">
      <div class="code-header">
        <div class="search-box"></div>
        <div class="operation-box">
          <el-button type="primary" @click="addStaffCode">新增员工活码</el-button>
        </div>
      </div>
      <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          height="calc(100vh - 170px)"
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="二维码" width="120">
          <template slot-scope="scope">
            <div class="code-preview">
              <svg v-if="scope.row.type==='BATCH'" t="1624433612578" class="icon" viewBox="0 0 1024 1024" version="1.1"
                   xmlns="http://www.w3.org/2000/svg" p-id="2464" width="48" height="48">
                <path
                    d="M0 0m51.2 0l921.6 0q51.2 0 51.2 51.2l0 921.6q0 51.2-51.2 51.2l-921.6 0q-51.2 0-51.2-51.2l0-921.6q0-51.2 51.2-51.2Z"
                    fill="#EBECF0" p-id="2465"></path>
                <path
                    d="M1024 921.6v51.2a51.2 51.2 0 0 1-51.2 51.2H51.2a51.2 51.2 0 0 1-51.2-51.2v-51.2a51.2 51.2 0 0 0 51.2 51.2h921.6a51.2 51.2 0 0 0 51.2-51.2z"
                    fill="#5E6C84" p-id="2466"></path>
                <path d="M1024 460.8v460.8a51.2 51.2 0 0 1-51.2 51.2H51.2a51.2 51.2 0 0 1-51.2-51.2V460.8z"
                      fill="#97A0AF" p-id="2467"></path>
                <path
                    d="M371.2 0m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2468"></path>
                <path
                    d="M524.8 51.2m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2469"></path>
                <path
                    d="M371.2 102.4m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2470"></path>
                <path
                    d="M524.8 153.6m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2471"></path>
                <path
                    d="M371.2 204.8m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2472"></path>
                <path
                    d="M524.8 256m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2473"></path>
                <path
                    d="M524.8 358.4m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2474"></path>
                <path
                    d="M371.2 409.6m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2475"></path>
                <path
                    d="M371.2 307.2m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2476"></path>
                <path
                    d="M467.968 795.136H307.2V768l111.616-143.872h-102.4v-33.28h153.6V614.4l-115.2 146.944h113.152zM542.72 796.16h-35.328v-204.8h35.328zM589.824 591.36h91.136a61.44 61.44 0 0 1 45.056 16.896 58.88 58.88 0 0 1 17.408 44.032 59.904 59.904 0 0 1-16.896 44.032 62.976 62.976 0 0 1-46.592 16.896H624.64v81.92h-35.328z m35.328 88.064h47.104a45.056 45.056 0 0 0 27.648-6.656 25.6 25.6 0 0 0 8.192-21.504q0-26.624-35.328-26.624h-48.128z"
                    fill="#FFFFFF" p-id="2477"></path>
              </svg>
              <el-image v-else :src="scope.row.externalContactQrCode"></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="100">
        </el-table-column>

        <el-table-column prop="scanNum" label="已加好友数" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.scanNum">{{ scope.row.scanNum }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column label="使用员工数" min-width="100" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.employeeIds |memberLen }}</div>
          </template>
        </el-table-column>
        <!--<el-table-column prop="type" label="类型" width="80">
          <template slot-scope="scope">
            <div>多人</div>
          </template>
        </el-table-column>-->
        <el-table-column label="标签" min-width="200">
          <template slot-scope="scope">
            <div class="code-tag">
              <el-tag
                  v-for="item in scope.row.tags"
                  :key="item.name"
                  :type="item.type"
                  size="mini"
                  effect="dark"
              >
                {{ item.name }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="100" align="center">
          <template slot-scope="scope">{{ new Date(scope.row.createTime).Format('yyyy-MM-dd hh:mm:ss') }}</template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button @click="editStaffCode(scope.row)" type="text" size="small">编辑</el-button>
            <el-button type="text" size="small" @click="notifyUser(scope.row)">通知使用者</el-button>
            <el-button type="text" size="small" @click="deleteStaffCode(scope.row.id)">删除</el-button>
            <el-link v-if="scope.row.type === 'BATCH'" :href="scope.row.contactCodesZipFile" target="_blank"
                     :underline="false" style="padding: 0 4px">
              <el-button type="text" size="small">下载</el-button>
            </el-link>
            <el-button v-else type="text" size="small" @click="downLoadCode(scope.row.externalContactQrCode,scope.row)">
              下载
            </el-button>

            <!--   <el-link :href="scope.row.externalContactQrCode" target="_blank" :underline="false" style="padding: 0 4px"><el-button type="text" size="small">下载二维码</el-button></el-link>-->

          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 添加编辑活码抽屉 -->
    <el-drawer
        :title="codeDrawerTitle"
        :visible.sync="editCodeDrawer"
        size="70%"
        direction="rtl">
      <div>
        <div class="drawer-container">
          <div class="drawer-form-content">
            <el-form :model="form">
              <el-form-item label="活码名称" label-width="80px">
                <el-input v-model="form.name" autocomplete="off" placeholder="请输入活码名称"></el-input>
              </el-form-item>
              <el-form-item label="活码类型" label-width="80px">
                <el-radio-group v-model="form.type" @change="codeTypeOnchange">
                  <el-radio-button label="SINGLE">单人</el-radio-button>
                  <el-radio-button label="BATCH">批量单人</el-radio-button>
                  <el-radio-button label="MULTI">多人</el-radio-button>

                </el-radio-group>
              </el-form-item>
              <el-form-item label="使用员工" label-width="80px">
                <!--<el-cascader
                  v-model="memberIdList"
                  :options="form.memberList"
                  :props="form.props"
                  collapse-tags
                  filterable
                  :show-all-levels="false"
                  clearable></el-cascader>-->
                <div
                    class="bind-bot-self-tree-box"

                >
                  <div
                      @click.stop="
                                                    setActiveTreeIndex
                                                "
                      :class="['selected-box']"
                  >
                    <div class="tag-box">
                      <span class="placeholder" v-if="memberShowTag.length===0">请点击选择使用员工</span>
                      <el-tag
                          v-for="(tagCell, tagCellIndex) in memberShowTag"
                          :key="tagCellIndex"
                          size="mini"
                          @close="handleCloseOrganization(tagCellIndex,tagCell.id)"
                          closable
                      >{{ tagCell.name }}
                      </el-tag
                      >
                    </div>
                    <!-- <div class="handle-teg-box">
                        <span v-show="activeTreeIndex == index" class="el-icon-arrow-up"></span>
                        <span v-show="activeTreeIndex != index" class="el-icon-arrow-down"></span>
                    </div> -->

                  </div>
                </div>
              </el-form-item>
              <el-form-item label="标签" label-width="80px">
                <div class="form-tag">
                  <el-tag
                      v-for="tag in showTagsList"
                      :key="tag.name"
                  >
                    {{ tag.name }}
                  </el-tag>
                </div>
                <el-button size="small" type="primary" @click="openSelectTag">选择标签</el-button>
              </el-form-item>
              <!--            <el-form-item label="发送名片" label-width="80px">
                            <div class="welcome-content">
                              <div class="welcome-status">
                                <el-switch
                                    v-model="welcomeConfig.sendBusinessCard"
                                    active-color="#13ce66"
                                    disabled
                                    @click.native="changSendBusinessCard(welcomeConfig.sendBusinessCard)"
                                >
                                </el-switch>
                              </div>
                            </div>
                          </el-form-item>-->
              <el-form-item label="欢迎语" label-width="80px">
                <div class="welcome-content">
                  <div class="welcome-status">
                    <el-switch
                        v-model="welcomeConfig.enable"
                        active-color="#13ce66"
                        disabled
                        @click.native="changEnable(welcomeConfig.enable)"
                    >
                    </el-switch>
                  </div>
                  <welcome-type :welcome-config="welcomeConfig" :selectedGroupType="codeStaff"></welcome-type>
                </div>
              </el-form-item>

            </el-form>
          </div>
          <div class="drawer-preview">

            <dialogue :welcome-config="welcomeConfig" :preview="priview" :source="codeStaff"></dialogue>
            <div class="code-preview-download">

              <svg v-if="form.type==='BATCH'" t="1624433612578" class="icon" viewBox="0 0 1024 1024" version="1.1"
                   xmlns="http://www.w3.org/2000/svg" p-id="2464" width="160" height="160">
                <path
                    d="M0 0m51.2 0l921.6 0q51.2 0 51.2 51.2l0 921.6q0 51.2-51.2 51.2l-921.6 0q-51.2 0-51.2-51.2l0-921.6q0-51.2 51.2-51.2Z"
                    fill="#EBECF0" p-id="2465"></path>
                <path
                    d="M1024 921.6v51.2a51.2 51.2 0 0 1-51.2 51.2H51.2a51.2 51.2 0 0 1-51.2-51.2v-51.2a51.2 51.2 0 0 0 51.2 51.2h921.6a51.2 51.2 0 0 0 51.2-51.2z"
                    fill="#5E6C84" p-id="2466"></path>
                <path d="M1024 460.8v460.8a51.2 51.2 0 0 1-51.2 51.2H51.2a51.2 51.2 0 0 1-51.2-51.2V460.8z"
                      fill="#97A0AF" p-id="2467"></path>
                <path
                    d="M371.2 0m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2468"></path>
                <path
                    d="M524.8 51.2m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2469"></path>
                <path
                    d="M371.2 102.4m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2470"></path>
                <path
                    d="M524.8 153.6m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2471"></path>
                <path
                    d="M371.2 204.8m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2472"></path>
                <path
                    d="M524.8 256m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2473"></path>
                <path
                    d="M524.8 358.4m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2474"></path>
                <path
                    d="M371.2 409.6m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2475"></path>
                <path
                    d="M371.2 307.2m17.92 0l92.16 0q17.92 0 17.92 17.92l0 15.36q0 17.92-17.92 17.92l-92.16 0q-17.92 0-17.92-17.92l0-15.36q0-17.92 17.92-17.92Z"
                    fill="#5E6C84" p-id="2476"></path>
                <path
                    d="M467.968 795.136H307.2V768l111.616-143.872h-102.4v-33.28h153.6V614.4l-115.2 146.944h113.152zM542.72 796.16h-35.328v-204.8h35.328zM589.824 591.36h91.136a61.44 61.44 0 0 1 45.056 16.896 58.88 58.88 0 0 1 17.408 44.032 59.904 59.904 0 0 1-16.896 44.032 62.976 62.976 0 0 1-46.592 16.896H624.64v81.92h-35.328z m35.328 88.064h47.104a45.056 45.056 0 0 0 27.648-6.656 25.6 25.6 0 0 0 8.192-21.504q0-26.624-35.328-26.624h-48.128z"
                    fill="#FFFFFF" p-id="2477"></path>
              </svg>
              <el-image style="height:160px;width:160px" :src="externalContactQrCode" v-else></el-image>
              <span style="margin-top:15px">二维码预览</span>
            </div>
          </div>
        </div>
        <div slot="footer" class="drawer-footer">
          <el-button @click="editCodeDrawer = false">取 消</el-button>
          <el-button type="primary" @click="addCode">确 定</el-button>
        </div>
      </div>
    </el-drawer>

    <!--选择标签-->
    <el-dialog
        title="选择客户标签"
        :close-on-click-modal="false"
        :visible.sync="staffCodeDialogVisibleTag"
        width="50%"
    >
      <tag-selection ref="tagSelection"></tag-selection>
      <span slot="footer" class="dialog-footer">
    <el-button @click="cacelCode">取 消</el-button>
    <el-button type="primary" @click="checkCode">确 定</el-button>
  </span>
    </el-dialog>
    <!--选择成员-->
    <el-dialog
        title="选择成员"
        :visible.sync="memberDialogTableVisible"
        :close-on-click-modal="false"
        class="dynamicCodeDialog"
        append-to-body
        width="600px"
        top="4vh"
    >
      <div class="bind-bot-self-tree">
        <el-tree
            :data="form.memberList"
            node-key="id"
            :default-expand-all="defaultExpandAll"
            :default-expanded-keys="treeExpandData"
            :props="defaultProps"
            :expand-on-click-node="false">
                      <span
                          class="custom-tree-node"
                          slot-scope="{
                              node,
                              data,
                          }"
                      >
                          <div style="display: flex;justify-content: flex-start;align-items: center">
                              <span v-if="!data.isMember">
                                  <i class="arsenal_icon arsenalsitemap1"
                                     style="font-size: 14px;padding-right: 4px;display: flex;align-items: center"></i>
                              </span>
                              <span v-if="data.isMember">
                                  <i class="arsenal_icon arsenaluser1"
                                     style="font-size: 14px;padding-right: 4px;display: flex;align-items: center"></i>
                              </span>
                              <span>{{ node.label }}</span>
                          </div>
                          <span>
                              <el-checkbox
                                  :disabled="data.disabled||memberIdList.length>=100"
                                  @change="changeCheckedOrg(node,data)"
                                  v-model="data.checked"
                                  v-if="form.type!=='SINGLE'"
                              ></el-checkbox>
                            <el-radio-group
                                v-model="memberRadioId"
                                @change="radioChange"
                                v-else
                            >
                                                            <el-radio :label="data">
                                                              {{ labelNull }}
                                                            </el-radio>
                                                        </el-radio-group>
                          </span>
                      </span>
        </el-tree>
      </div>
      <div class="warning-title">
        <el-alert
            title="使用员工只能选择已配置了客户联系和客户群权限的员工，可以在【企业微信管理后台->客户联系->权限配置->客户联系和客户群的使用范围】进行配置"
            type="warning"
            :closable="false">
        </el-alert>

      </div>
      <div slot="footer" class="dialog-footer">

        <el-button @click="memberDialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="memberDialogTableVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Material from "./../../components/materialSelection"
import WelcomeType from "./compontent/welcomeType";
import Dialogue from "./compontent/dialogue";
import tagSelection from "../../components/tagSelection";
import {showParent} from "@/assets/js/getChildrenLeng";

export default {
  name: "",
  components: {Dialogue, WelcomeType, Material, tagSelection},
  data() {
    return {

      tableData: [],
      codeDrawerTitle: '',
      editCodeDrawer: false,
      addMiniProgramDialogVisible: false,
      deleteStaffCodeDialogVisible: false,
      memberDialogTableVisible: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        resource: '',
        desc: '',
        type: 'MULTI',
        props: {multiple: true, emitPath: false, value: 'id', label: 'name', children: 'children'},
        options: [],
        memberList: []
      },
      welcomeStatus: true,
      selectedWelcomeContent: 'TEXT',
      textarea: '',
      materialDialogVisible: false,
      inputVisible: false,
      inputValue: '',
      memberIdList: [],
      memberShowTag: [],
      welcomeConfig: {
        enable: true,
        attachments: [],
        sendBusinessCard: false,
        text: {
          content: ""
        }
      },
      fileList: [],
      miniProgramTitle: '',
      miniProgramAppID: '',
      miniProgramPage: '',
      dynameic: '',
      codeStaffId: '',
      externalContactQrCode: 'https://wwcdn.weixin.qq.com/node/wework/mobilekit/images/202005091515.bdc7d40604.png',
      priview: '欢迎语预览',
      tagsList: [],
      staffCodeDialogVisibleTag: false,
      showTagsList: [],
      sendRecord: false,
      defaultExpandAll: true,
      defaultProps: {
        children: "children",
        label: "name",
      },
      treeExpandData: [],
      codeStaff: 'codeStaff',
      checkMemberTree: 'checkMemberTree',
      labelNull: '',
      memberRadioId: {}
    };
  },
  filters: {
    memberLen(value) {
      if (value) {
        console.log(value)
        return value.length
      } else {
        return 0
      }

    }
  },
  methods: {
    addStaffCode() {
      this.codeDrawerTitle = '新增员工活码';
      this.editCodeDrawer = true
      this.form.name = ''
      this.memberRadioId = {}
      this.memberIdList = []
      this.welcomeConfig.enable = true
      this.welcomeConfig.sendBusinessCard = false
      this.welcomeConfig.text.content = ''
      this.showTagsList = []
      this.welcomeConfig.attachments = []
      this.externalContactQrCode = 'https://wwcdn.weixin.qq.com/node/wework/mobilekit/images/202005091515.bdc7d40604.png'
    },
    //编辑
    editStaffCode(item) {
      this.codeDrawerTitle = '编辑员工活码';
      this.editCodeDrawer = true
      this.externalContactQrCode = ''
      this.welcomeConfig.enable = true
      this.welcomeConfig.text.content = ''
      this.welcomeConfig.attachments = []
      this.memberRadioId = {}
      /* if (item.type==='SINGLE'&&item.employeeIds){
         this.memberRadioId=item.employeeIds
       }*/

      console.log('item', item)
      this.memberIdList = []
      this.form.name = item.name
      this.form.type = item.type
      let memberIds = []
      if (item.originSelectIds) {
        memberIds = item.originSelectIds
      } else if (item.employeeIds) {
        memberIds = item.employeeIds
      }
      this.seachSelectUserIds(this.form.memberList, memberIds)
      console.log(this.memberIdList)
      /*去重*/
      let obj = {};
      let peon = this.memberIdList.reduce((cur, next) => {
        obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
        return cur;
      }, [])
      this.memberIdList = peon
      if (this.memberIdList.length > 0) {
        this.memberRadioId = this.memberIdList[0]
      }
      console.log(this.memberRadioId)
      this.showTagsList = JSON.parse(JSON.stringify(item.tags))
      if (item.welcomeConfig) {
        this.welcomeConfig.enable = JSON.parse(JSON.stringify(item.welcomeConfig.enable))
        this.welcomeConfig.text.content = JSON.parse(JSON.stringify(item.welcomeConfig.text.content))
        this.welcomeConfig.attachments = JSON.parse(JSON.stringify(item.welcomeConfig.attachments))
        if (item.welcomeConfig.sendBusinessCard !== null) {
          this.welcomeConfig.sendBusinessCard = JSON.parse(JSON.stringify(item.welcomeConfig.sendBusinessCard))
        }
      }
      this.codeStaffId = item.id
      if (item.externalContactQrCode) {
        this.externalContactQrCode = item.externalContactQrCode
      }

    },
    //通知
    notifyUser(item) {
      console.log(item)
      let url = '/scrm-api/contact-code/notify/' + item.id
      let string = '您的企业微信客户联系二维码已生成,可登录果然私域智能运营系统进行查看及下载.[' + item.id + ']'
      this.$http.post(url, string).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.$message({
            message: '通知使用者成功',
            duration: 3000,
            type: 'success'
          })
        }
      })
    },
    downLoadCode(Img, data) {
      var image = new Image();
      console.log(data)
      console.log(new Date(data.createTime).Format('yyyy-MM-dd hh:mm:ss'))
      let time = new Date(data.createTime).Format('yyyy-MM-dd hh:mm:ss')
      let res = time.replace(/[^\d]/g, '')
      console.log(res)
      image.setAttribute("crossOrigin", "anonymous");
      var _this = this;
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        let round = Math.round(Math.random() * data.memberIdList.length)
        a.download = '员工活码_' + res; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = Img;
    },
    //删除员工活码
    deleteStaffCode(id) {
      this.codeStaffId = id
      this.$confirm('确定删除员工活码, 是否继续?', '删除员工活码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = '/scrm-api/contact-code/' + id
        this.$http.delete(url).then(res => {
          if (res.status === 200) {
            this.$message({
              message: '删除员工活码成功',
              type: 'success',
              duration: 2000

            })
            this.getCodeStaff()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          duration: 2000
        });
      });
    },

    //选择标签
    checkCode() {
      this.$nextTick(() => {
        this.showTagsList = this.$refs.tagSelection.tags
        this.staffCodeDialogVisibleTag = false
      })

    },
    //取消选择标签
    cacelCode() {
      this.staffCodeDialogVisibleTag = false
    },
    handleSelectionChange() {

    },
    handleTagClose(tag) {
      console.log(tag)
      this.$nextTick(() => {
        if (this.$refs.tagSelection !== undefined) {
          this.$refs.tagSelection.deleteTag(tag)
          this.showTagsList = this.$refs.tagSelection.tags
        } else {
          this.$message.warning('请先打开选择标签再删除')
        }

      })
    },

    //获取员工活码
    getCodeStaff() {
      let url = '/scrm-api/contact-code'
      this.$http.get(url).then(res => {

        this.tableData = (res.data).reverse()
      })
    },
    changEnable(value) {
      console.log(value)
      this.$confirm('是否关闭欢迎语功能, 是否继续?', '关闭欢迎语', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.welcomeConfig.enable = !value
        this.$message({
          type: 'success',
          message: '关闭成功!',
          duration: 2000
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消关闭',
          duration: 2000
        });
      });

    },
    changSendBusinessCard(value) {
      console.log(value)
      this.$confirm('是否取消发送名片功能, 是否继续?', '取消发送名片', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.welcomeConfig.sendBusinessCard = !value
        this.$message({
          type: 'success',
          message: '取消发送名片!',
          duration: 2000
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消关闭',
          duration: 2000
        });
      });

    },
    //新增员工活码
    addCode() {
      let url = '/scrm-api/contact-code'
      console.log('show tag list', this.showTagsList)
      let showTags = []
      if (this.showTagsList !== null && this.showTagsList.length > 0) {
        showTags = this.showTagsList.map((tag) => tag.id)
      }
      console.log('memberIdList', this.memberIdList)
      let info = {
        memberIdList: this.memberIdList.map((m) => m.id),
        originSelectIds: this.memberIdList.map((m) => m.id),
        employeeIds: this.memberIdList.filter(m => m.isMember == true).map((m) => m.id),
        name: this.form.name,
        type: this.form.type,
        tagIds: showTags,
        welcomeConfig: this.welcomeConfig
      }
      if (this.form.name === '') {

        this.$message({
          message: '活码名称不能为空',
          duration: 2000,
          type: 'warning'
        })
        return
      }
      if (info.employeeIds.length === 0) {
        this.$message({
          message: '请选择使用员工',
          duration: 2000,
          type: 'warning'
        })
        return;
      }
      if (this.codeDrawerTitle == '新增员工活码') {
        this.$http.post(url, info).then(res => {
          if (res.status === 200) {
            this.$message({
              message: '添加员工活码成功',
              type: 'success',
              duration: 2000

            })
            this.getCodeStaff()
            this.editCodeDrawer = false
          }
        })
      }
      if (this.codeDrawerTitle == '编辑员工活码') {
        url += '/' + this.codeStaffId
        this.$http.put(url, info).then(res => {
          console.log(res)
          if (res.status === 200) {
            this.$message({
              message: '更改员工活码成功',
              type: 'success',
              duration: 2000

            })
            this.getCodeStaff()
            this.editCodeDrawer = false
          }
        })
      }
    },
    //获取员工
    getWeWorkList() {
      let url = '/scrm-api/we-work/member'
      this.$http.get(url).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.form.memberList = res.data
          console.log(this.form.memberList)
          this.setAttr4MemberList(this.form.memberList, (item) => {
            this.$set(item, 'checked', false);
          })
          this.getRoleTreeRootNode(this.form.memberList[0].id);
        }
      })
    },
    // 获取树形结构默认展开节点
    getRoleTreeRootNode(provincialCenterId) {
      this.treeExpandData.push(provincialCenterId)
    },
    setAttr4MemberList(list, setAttrFun) {
      if (setAttrFun == null) {
        return list;
      }
      if (list !== null) {
        list.forEach(item => {
          setAttrFun(item);
          this.setAttr4MemberList(item.children, setAttrFun)
        })
      } else
        return list
    },
    //打开标签组
    openSelectTag() {
      this.staffCodeDialogVisibleTag = true
      this.$nextTick(() => {
        this.$refs.tagSelection.tags = this.showTagsList
        let ids = []
        console.log(this.showTagsList)
        if (this.showTagsList !== null) {
          for (let i = 0; i < this.showTagsList.length; i++) {
            ids.push(this.showTagsList[i].id)
          }
          this.$refs.tagSelection.$refs.tree.setCheckedKeys(ids)
        } else {
          this.$refs.tagSelection.$refs.tree.setCheckedKeys([])
        }

      })
    },

    codeTypeOnchange(type) {
      if (type === 'SINGLE') {
        if (this.memberIdList.length > 0) {
          let one = this.memberIdList[0];
          this.memberIdList = [one];
          this.setAttr4MemberList(this.form.memberList, (item) => {
            if (item.id != one.id) {
              item.checked = false
            }
          });
        }

      }
    },
    setActiveTreeIndex() {
      console.log('123')
      /*  this.showTree=!this.showTree*/
      this.memberDialogTableVisible = true
      let arr = [];
      this.memberIdList.forEach((item) => {
        arr.push(item.id);
      })
      console.log('arrarr', arr)
      setTimeout(() => {
        this.initShowOrTree(arr, true, "init");
        setTimeout(() => {
          showParent(this.memberIdList, 0)
        }, 100)
      }, 100);
    },
    changeOrgChildrenProperties(list, fun) {
      if (list == null || list.length == 0 || fun == null) {
        return;
      }
      list.forEach(item => {
        fun(item);
        this.changeOrgChildrenProperties(item.children, fun);
      });

    },
    changeCheckedOrg(node, data) {
      console.log(data);
      this.changeOrgChildrenProperties(data.children, (item) => item.checked = data.checked);
      if (data.checked) {
        this.changeOrgChildrenProperties([data], (item) => this.memberIdList.unshift(item));
      } else {
        this.changeOrgChildrenProperties([data], (item) => {
          this.memberIdList.forEach((cell, cellIndex) => {
            if (cell.id == item.id) {
              this.memberIdList.splice(cellIndex, 1);
            }
          });
        });

      }
      this.memberIdList = [...this.memberIdList];
      console.log("memberIdList", this.memberIdList);
      /* let checkLength = 0
       showParent(this.memberIdList,checkLength)*/
    },
    radioChange(value) {
      console.log(value)
      this.memberIdList = []
      this.memberIdList.push(value)
      console.log(this.memberRadioId)
    },
    handleCloseOrganization(tagCellIndex, id) {
      this.initShowOrTree([id], false, "close");
      if (this.memberIdList.length > 0) {
        this.memberIdList.forEach((item, index) => {
          if (item.id === id) {
            this.memberIdList.splice(index, 1)
          }
        })
      }

    },
    initShowOrTree(handleIdArr, isChecked, type) {
      const formOrgTree = (arr, handleIdArr, isChecked) => {
        if (type == "close") {
          arr.forEach((item) => {
            if (handleIdArr.indexOf(item.id) != -1) {
              item.checked = isChecked;
              if (item.children) {
                formOrgTree(item.children, handleIdArr, isChecked);
              }
            } else {
              if (item.children) {
                formOrgTree(item.children, handleIdArr, isChecked);
              }
            }
          });
        } else {
          arr.forEach((item) => {
            if (handleIdArr.indexOf(item.id) != -1) {
              item.checked = isChecked;
              if (item.children) {
                formOrgTree(item.children, handleIdArr, isChecked);
              }
            } else {
              item.checked = !isChecked;
              if (item.children) {
                formOrgTree(item.children, handleIdArr, isChecked);
              }
            }
          });
        }
        return arr;
      };
      this.form.memberList = [
        ...formOrgTree(this.form.memberList, handleIdArr, isChecked),
      ];
    },
    /*遍历人员信息*/
    seachSelectUserIds(value, ids) {
      console.log(ids)
      if (value !== null) {
        for (let i = 0; i < value.length; i++) {
          if (ids) {
            if (ids.indexOf(value[i].id) !== -1) {
              this.memberIdList.push(value[i])
              this.seachSelectUserIds(value[i].children, ids)
            } else {
              this.seachSelectUserIds(value[i].children, ids)
            }
          }

        }
      } else
        return
    },
    memberDialog() {
      this.memberDialogTableVisible = false
      this.$nextTick(() => {
        console.log('memberDialog memberIdList', this.$refs.memberTree.memberIdList)
        let memberIds = JSON.parse(JSON.stringify(this.$refs.memberTree.memberIdList))
        let obj = {};
        let peon = memberIds.reduce((cur, next) => {
          obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
          return cur;
        }, [])
        this.memberIdList = peon

      })
    },

  },
  mounted() {
    this.getWeWorkList()
    this.getCodeStaff()
  },
  watch: {
    memberIdList: {
      handler(tags) {
        this.memberShowTag = []
        if (tags != null && tags.length > 0) {
          tags.forEach(item => {
            if (item.isMember) {
              this.memberShowTag.push(item)
            }
          })
          let obj = {};
          let peon = this.memberShowTag.reduce((cur, next) => {
            obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
            return cur;
          }, [])
          this.memberShowTag = peon

        }
        console.log('memberShowTag', this.memberShowTag)

      },
      deep: true
    }
  }
};
</script>

<style lang="less">
@import url("../../assets/less/leadsSource/dynamicCodeStaff.less");

.drawer-container {
  .material-box {
    width: 100% !important;

    .material-content {
      padding: 0 !important;

      .article-box {
        .article-box-content {
          margin-top: 0 !important;
        }
      }
    }
  }

  .welcome-config {
    .welcome-config-textarea {
      border-bottom: 1px solid #DCDFE6;

    }

    .welcome-config-file {
      display: flex;
      align-items: center;

      .selected-name {
        margin-right: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.code {

}

.bind-bot-self-tree-box {
  text-align: left;
  flex: auto;
  position: relative;
  line-height: 28px;
  height: 56px;
  padding: 0;

  .selected-box {
    border: solid 1px #e4e7ed;
    height: 56px;
    overflow-y: auto;
    display: flex;
    justify-content: space-between;

    .tag-box {
      height: 56px;
      flex: auto;

      .placeholder {
        height: 56px;
        line-height: 56px;
        color: #c0c4cc;
        margin-left: 8px;
      }

      .el-tag {
        margin-left: 6px;
      }
    }

    .handle-teg-box {
      flex: none;
      width: 15px;
      margin-left: 10px;
      line-height: 100%;
      cursor: pointer;
      position: absolute;
      right: 1px;
      top: 20px;

      span {
        height: 10px;
        flex: none;
      }
    }
  }

}

.dynamicCodeDialog {
  /*.bind-bot-self-tree {
    padding-top: 5px;
    padding-left: 6px;
    z-index: 99999999999999999;
    position: relative;
    top: 3px;
    background-color: white;
    border-left: solid 1px #e4e7ed;
    border-right: solid 1px #e4e7ed;
    border-bottom: solid 1px #e4e7ed;
    border-radius: 6px;
    max-height: 400px;
    overflow: auto;
    min-height: 200px;

  }*/

  .bind-bot-self-tree {
    max-height: calc(100vh - 370px);
    min-height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
  }

  .warning-title {
    margin-top: 12px;
  }
}


</style>